import { deleteData, fetchData, formPost, patchData, postData, updateData } from "./net";
import config from "../config";
const { sellerHostname, crmHostname, glHostname } = config;

export const authenticate = (callback) => {
  const url = `${sellerHostname}/ev/auth/isloggedin`;

  fetchData(url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      callback((status !== 200), data);
    } catch(e) {
      console.error("Error in authenticate", e);
    }
  });
};

export const login = (data, callback) => {
  const url = `${sellerHostname}/ev/auth/login`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

export const logout = (callback) => {
  const url = `${sellerHostname}/ev/auth/logout`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const saveVehicleModel = (data, callback) => {
  const url = `${sellerHostname}/ev/oem/addModel`;

  postData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const updateVehicleModel = (data, callback) => {
  const url = `${sellerHostname}/ev/oem/updateModel`;

  patchData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const loginOTP = (data, callback) => {
  const url = `${sellerHostname}/ev/auth/loginWithOTP`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

/*
export const getNotifications = () => {
  const DUMMY_NOTIFS = [
    { idx: 1,  typ: 104, text: "Chassis number JH4KA3261JC024072",       ts: Date.now(),   },
    { idx: 2,  typ: 104, text: "Chassis number JH4KA3261JC024072",       ts: 1677066120000 },
    { idx: 3,  typ: 202, text: "Chassis number JH4KA3261JC024072",       ts: 1677061380000 },
    { idx: 4,  typ: 301, text: "Dealership Name ABC - Quantity: 100",    ts: 1677044520000 },
    { idx: 5,  typ: 303, text: "Dealership Name ABC - Order ID: O13832", ts: 1676974980005 },
    { idx: 6,  typ: 302, text: "Dealership Name ABC - Order ID: O13832", ts: 1676974980010 },
    { idx: 7,  typ: 102, text: "", ts: 1676974980020 },
    { idx: 8,  typ: 301, text: "", ts: 1676974880030 },
    { idx: 9,  typ: 302, text: "", ts: 1676974780000 },
    { idx: 10, typ: 303, text: "", ts: 1676974680000 },
  ];

  const DUMMY_RESPONSE = {
    unreadCount: 0,
    notifs: DUMMY_NOTIFS,
  };

  return new Promise((resolve, reject) => {
    window.setTimeout(() => {
      resolve(DUMMY_RESPONSE);
    }, 50);
  });
};
*/

export const getDriveModes = (callback) => {
  const DUMMY_MODES = [
    { idx: 1, label: "Eco" },
    { idx: 2, label: "City" },
    { idx: 3, label: "Power" },
  ];

  return new Promise((resolve, reject) => {
    resolve(DUMMY_MODES);
  });
};

export const getModels = (callback) => {
  const url = `${sellerHostname}/ev/oem/getAllModelsCount`;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in getModels", e);
        reject(e);
      }
    });
  });
};

export const getWidgetData = (range, widgets, models) => {
  let url = `${sellerHostname}/ev/oem/analytics/overallStats`;
  url += `?from=${range.from}&to=${range.to}&id=` + widgets.join("&id=");
  if (models) url += `&model=` + models.join("&model=");

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in getWidgetData", e);
        reject(e);
      }
    });
  });
};

export const getStatsData = (range, module, qs) => {
  let url = `${sellerHostname}/ev/oem/analytics/modelWiseStat`;
  url += `?id=${module}&from=${range.from}&to=${range.to}&`;
  if (qs) url += new URLSearchParams(qs);

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in getWidgetData", e);
        reject(e);
      }
    });
  });
};

export const getAllModels = () => {
  const url = `${sellerHostname}/ev/oem/getModels`;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in authenticate", e);
        reject(e);
      }
    });
  });
};

export const discontinueModelRequest = (data) => {
  const url = `${sellerHostname}/ev/oem/discontinueModelOTP`;

  return new Promise((resolve, reject) => {
    postData(data, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200 || status === 201) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in saveWebToken", e);
        reject(e);
      }
    });
  });
};

export const discontinueModel = (data) => {
  const url = `${sellerHostname}/ev/oem/discontinueModel`;

  return new Promise((resolve, reject) => {
    postData(data, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in saveWebToken", e);
        reject(e);
      }
    });
  });
};

export const getVehicleStats = (date, statType, qs) => {
  let url = `${sellerHostname}/ev/oem/analytics/vehicleDetails?from=${date.from}&to=${date.to}&id=${statType}`;
  if (qs) url += "&" + new URLSearchParams(qs);

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in saveWebToken", e);
        reject(e);
      }
    });
  });
};

export const getFaultyMotors = (date, faults, callback) => {
  let url = `${sellerHostname}/ev/oem/analytics/faultyMotorsCount?from=${date.from}&to=${date.to}`;

  if(faults && faults.length) {
    faults.forEach(fault => {
      url += `&fault=${fault}`
    })
  }

  fetchData(url, (response) => {
    const obj = JSON.parse(response.response);
    if (response.status === 200) {
      callback(null, obj.data, obj.message, obj);
    } else callback(obj.message, null, obj.data, obj);
  });
};

export const getMotorFaultTypes = () => {
  const DUMMY_DATA = [
    {idx: 1, nm: "Drive",},
    {idx: 2, nm: "Hall Sensor",},
    {idx: 3, nm: "High Current",},
    {idx: 4, nm: "High Load",},
    {idx: 5, nm: "High Motor Temperature",},
    {idx: 6, nm: "High Speed",},
    {idx: 7, nm: "High Temperature",},
    {idx: 8, nm: "High Voltage",},
    {idx: 9, nm: "Low Voltage",},
    {idx: 10, nm: "Mosfet",},
    {idx: 11, nm: "Motor Blocking",},
    {idx: 12, nm: "Motor Lost Hall",},
    {idx: 13, nm: "Motor Phase Loss",},
    {idx: 14, nm: "Motor Stuck",},
    {idx: 15, nm: "Throttle",},
  ];

  return new Promise((resolve, reject) => {
    window.setTimeout(() => {
      resolve(DUMMY_DATA);
    }, 200);
  });
}

export const getApplicationServerKey = () => {
  const url = `${sellerHostname}/ev/webpush/getVapidKey`;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in getApplicationServerKey", e);
        reject(e);
      }
    });
  });
};

export const saveWebToken = (data) => {
  const url = `${sellerHostname}/ev/webpush/saveWebToken`;

  return new Promise((resolve, reject) => {
    postData(data, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in saveWebToken", e);
        reject(e);
      }
    });
  });
};

export const getClients = () => {
  let url = `${sellerHostname}/ev/lease/getClientsList`;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200){
          resolve(data)
        }
        else reject(data);
      } catch(e) {
        console.error("Error in getClientsData", e);
        reject(e);
      }
    });
  });
};

export const addDriver = (data, files) => {
  const url = `${sellerHostname}/ev/driver/addDriver`;

  return new Promise((resolve, reject) => {
    formPost(null, data, files, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in saveWebToken", e);
        reject(e);
      }
    });
  });
};

export const getVehiclesInfo = (clientId, vid, callback) => {
  let url = `${sellerHostname}/ev/inventory/getVehiclesInfo?`;
  if (clientId) url += `clientId=${clientId}&`;
  if (vid) url += `idx=${vid}`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getDriverOrVehicleStats = (vid, driverId, range, callback) => {
  let url = `${sellerHostname}/ev/stats/getStats?`;

  if (typeof vid === "object") url += `vidArr=[${vid}]&`
  else url += `vid=${vid}&`;

  if (driverId) url += `drId=${driverId}&`;
  if (range) url += `fromTs=${range.from}&toTs=${range.to}&`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const swapBattery = (data, callback) => {
  const url = `${sellerHostname}/ev/inventory/swapBatteryFromVehicle`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

export const getDriversInfo = (client, driver, usassignedOnly, assignedOnly, callback) => {
  let url = `${sellerHostname}/ev/driver/getDriverDetails?`;
  if (client) url += `clientId=${client}&`;
  if (driver) url += `idx=${driver}&`;
  if (usassignedOnly) url += `unassigned=true`;
  if (usassignedOnly) url += `unassigned=true`;
  if (assignedOnly) url += `assigned=true`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const saveClientDetails = (data, callback) => {
  const url = `${sellerHostname}/ev/lease/addClient`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const saveVehicleDetails = (data, callback) => {
  const url = `${sellerHostname}/ev/inventory/addVehiclesToInventory`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const saveBatteryDetails = (data, callback) => {
  const url = `${sellerHostname}/ev/inventory/addBatteryToInventory`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const getBatteriesData = (bId) => {
  let url = `${sellerHostname}/ev/inventory/getBatteriesInfo`;
  if (bId) {
    url += `?bId=${bId}`
  }

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(data);
        else reject(data);
      } catch (e) {
        console.error("Error in getBatteries", e);
        reject(e);
      }
    });
  });

}

export const getVehicleLeasedStats = (clientId) => {
  let url = `${sellerHostname}/ev/lease/getVehiclesModelCount?clientId=` + clientId;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) {
          resolve(data)
        }
        else reject(data);
      } catch(e) {
        console.error("Error in getLeasedVehicleStats", e);
        reject(e);
      }
    });
  });

}

export const getStatesByCountryId = (abbreviaions) => {
  // Default, india
  let url = `${crmHostname}/crm/geolocation/geolocation/getstatesbycountryid?`;
  if (abbreviaions) url += "abb=true";

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) resolve(data);
        else reject(data);
      } catch (e) {
        console.error("Error in getAllStates", e);
        reject(e);
      }
    });
  });
};

export const getLeasedVehPaymentStats = (clientId, range) => {
  const url = `${sellerHostname}/ev/payments/getPayments?clientId=` + clientId + `&fromTs=${range.from}&toTs=${range.to}`;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) {
          resolve(data)
        }
        else reject(data);
      } catch(e) {
        console.error("Error in getLeasedVehPaymentStats", e);
        reject(e);
      }
    });
  });
}

export const addPaymentForLeaseVeh = (data, files) => {

  // return new Promise((resolve, reject) => {
  //   resolve({ "message": "OK", "data": { "pmtMode": 1, "amt": 200000, "oemId": 101, "ts": 1721641001172, "cdt": 1721653108235, "pmtSrc": 2, "reqkey": "a6cV", "idx": 3499 } })
  // }
  // )
  const url = `${sellerHostname}/ev/payments/addPayment`;

  return new Promise((resolve, reject) => {
    formPost(null, data, files, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200){
           resolve(data)
        }
        else reject(data);
      } catch(e) {
        console.error("Error in addPaymentForLeaseVeh", e);
        reject(e);
      }
    });
  })
}

export const deletePaymentForLeaseVeh = (paymentId) => {
  const url = `${sellerHostname}/ev/payments/deletePayment?paymentId=${paymentId}`;

  return new Promise((resolve, reject) => {
    deleteData(null, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(data);
        else reject(data);
      } catch(e) {
        console.error("Error in deletePaymentForLeaseVeh", e);
        reject(e);
      }
    });
  })
}

export const getVehiclesForAssign = (clientId) => {
  let url = `${sellerHostname}/ev/inventory/getVehiclesInfo?clientId=` + clientId;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) {
          resolve(data)
        }
        else reject(data);
      } catch(e) {
        console.error("Error in getVehiclesForAssign", e);
        reject(e);
      }
    });
  });
};

export const getCitiesByStateID = (stateID, callback) => {
  const url = `${crmHostname}/crm/geolocation/geolocation/getcitiesbystateid?idx=${stateID}`;

  return new Promise((resolve, reject) => {
    fetchData(url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) resolve(data);
        else reject(data);
      } catch (e) {
        console.error("Error in getCitiesByStateID", e);
        reject(e);
      }
    });
  });
};

export const AddVehicleToLease = (data, callback) => {
  const url = `${sellerHostname}/ev/lease/addVehiclesToLease`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const assignDriver = (data, callback) => {
  const url = `${sellerHostname}/ev/driver/assignDriver`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const unassignDriver = (vid, callback) => {
  const url = `${sellerHostname}/ev/driver/unassignDriver`;

  if (url) {
    postData({ vid }, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const removeVehicle = (clientId, idx, callback) => {
  const url = `${sellerHostname}/ev/lease/removeVehicleFromLease`;

  if (url) {
    postData({ clientId, idx }, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const getBatteriesStatsByManf = (data) => {
  const url = `${sellerHostname}/ev/inventory/getBatteriesStatsByManf`;

  if (url) {
    return new Promise((resolve, reject) => {
      fetchData(url, ({ status, response }) => {
        try {
          const { data } = JSON.parse(response);
          if (status === 200) resolve(data);
          else reject(data);
        } catch (e) {
          console.error("Error in getBatteriesStatsByManf", e);
          reject(e);
        }
      });
    });
  }
};
export const getVehicleModelsCount = (data) => {
  const url = `${sellerHostname}/ev/lease/getVehiclesModelCount`;

  if (url) {
    return new Promise((resolve, reject) => {
      fetchData(url, ({ status, response }) => {
        try {
          const { data } = JSON.parse(response);
          if (status === 200) resolve(data);
          else reject(data);
        } catch (e) {
          console.error("Error in getLeasedVehiclesCount", e);
          reject(e);
        }
      });
    });
  }
};
export const assignVehicleToDriver = (vid, drId) => {
  const url = `${sellerHostname}/ev/driver/assignDriver`;

  let data ={
    vid: vid,
    drId: drId,
  }

  return new Promise((resolve, reject) => {
    postData(data, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(null, data);
        else reject(data);
      } catch(e) {
        reject(e);
      }
    });
  })
}

export const getGeofencesByClient = (client, idx) => {
  let url = `${sellerHostname}/ev/trigger/getGeoFenceByClientId?clientId=${client}&`;
  if (idx) url += `idx=${idx}`;

  if (url) {
    return new Promise((resolve, reject) => {
      fetchData(url, ({ status, response }) => {
        try {
          const { data } = JSON.parse(response);
          if (status === 200) resolve(data);
          else reject(data);
        } catch (e) {
          console.error("Error in getLeasedVehiclesCount", e);
          reject(e);
        }
      });
    });
  }
};

export const addNewGeofence = (geofence, callback) => {
  const url = `${sellerHostname}/ev/trigger/addGeoFence`;

  if (url) {
    postData(geofence, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const updateGeofence = (geofence, callback) => {
  const url = `${sellerHostname}/ev/trigger/updateGeoFence`;

  if (url) {
    postData(geofence, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const removeGeofence = (geofence, callback) => {
  const url = `${sellerHostname}/ev/trigger/deleteGeoFence`;

  if (url) {
    postData(geofence, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const updateDriverProfilePicture = (data, files) => {
  const url = `${sellerHostname}/ev/driver/editProfilePic`;

  return new Promise((resolve, reject) => {
    formPost(null, data, files, url, ({ status, response }) => {
      if (status === 200) resolve();
      else reject();
    });
  })
}

export const removeDriverProfilePicture = (data) => {
  const url = `${sellerHostname}/ev/driver/removeProfilePic`;

  return new Promise((resolve, reject) => {
    postData(data, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);

        if (status === 200) resolve(null, data);
        else reject(data);
      } catch(e) {
        reject(e);
      }
    });
  })
}
export const deleteVehicleFromInventory = (vid, cb) => {
  const url = `${sellerHostname}/ev/inventory/removeVehicleFromInventory`;

  deleteData({ vid }, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      cb(null, data);
    } else {
      cb(response || "failed");
    }
  });
}

export const deleteBatteryFromInventory = (bId, cb) => {
  const url = `${sellerHostname}/ev/inventory/removeBatteryFromInventory`;

  deleteData({ bId }, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      cb(null, data);
    } else {
      cb(response || "failed");
    }
  });
}

export const updateVehicleDetail = (data, callback) => {
  const url = `${sellerHostname}/ev/inventory/updateVehicleDetails`;

  patchData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const updateBatteryDetail = (data, callback) => {
  const url = `${sellerHostname}/ev/inventory/updateBatteryDetails`;

  patchData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getDealersAndDevices = (dealerId, callback) => {
  let url = `${sellerHostname}/b2b/dealer/getB2bAllDeviceStatus?`;
  if (dealerId) url += `idx=${dealerId}`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getOrderDetails = (orderId, dlrId, recent, callback) => {
  let url = `${sellerHostname}/b2b/order/getOrders?`;
  if (orderId) url += `orderId=${orderId}&`;
  if (dlrId) url += `dlrId=${dlrId}&`;
  if (recent) url += `recent=${true}&`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getAllOrders = (clientId, callback) => {
  let url = `${sellerHostname}/ev/inventory/getVehiclesInfo?`;
  if (clientId) url += `clientId=${clientId}&`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getAllDealers = (idx, callback) => {
  let url = `${sellerHostname}/b2b/dealer/getAllDealers?`;
  if (idx) url += `idx=${idx}&`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getSellerDealers = (callback) => {
  let url = `${sellerHostname}/b2b/dealer/getB2bAllDeviceStatus`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
}

export const placeOrder = (data, callback) => {
  const url = `${sellerHostname}/b2b/order/placeOrder`;
  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

export const markOrderAsReceived = (data, callback) => {
  const url = `${sellerHostname}/ev/auth/login`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

export const updateOrderStatus = (data, callback) => {
  const url = `${sellerHostname}/b2b/order/updateOrderStatus`;

  updateData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};


export const saveDealershipDetails = (data, callback) => {
  const url = `${sellerHostname}/b2b/dealer/insertNewDealer`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const editDealershipDetails = (data, callback) => {
  const url = `${sellerHostname}/b2b/dealer/updateDealer`;

  if (url) {
    patchData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const getDevices = (idx, stock, installed, callback) => {
  let url = `${sellerHostname}/b2b/dealer/getDeviceOrderDetails?`;
  if (idx) url += `idx=${idx}&`;
  if (stock && installed) url += ``;
  else if (stock) url += `stock=${stock}&`;
  else if (installed) url += `installed=${installed}&`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const mapDeviceToVehicle = (data, callback) => {
  const url = `${sellerHostname}/ev/inventory/addVehiclesToInventory`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      if (status === 200) {
        const { data } = JSON.parse(response);
        callback(null, data);
      } else {
        callback(response);
      }
    });
  }
};

export const getSpecificDevDetails = (imei, callback) => {
  let url = `${sellerHostname}/b2b/dealer/getDeviceOrderDetails?`;
  if (imei) url += `imei=${imei}`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
}

export const getPingTestStatus = (imei, callback) => {
  let url = `${sellerHostname}/b2b/device/getPingTestStatus?`;
  if (imei) url += `imei=${imei}`

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
}

export const getAllTransactions = (callback) => {
  let url = `${sellerHostname}/b2b/device/getDeviceStockHistory`;

  fetchData(url, ({ status, response }) => {
    if(status===200){
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
      console.error("Error in getTransactions");
    }
  });
}

export const getTransactions = (orderId, callback) => {
  let url = `${sellerHostname}/ev/payments/getPayments?`;
  if(orderId) url += `orderId=${orderId}`;
  else url += `txns=true`;

  fetchData(url, ({ status, response }) => {
    if(status===200){
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
      console.error("Error in getTransactions");
    }
  });
};

export const getSellerDevicesInStock = (callback) => {
  const url = `${sellerHostname}/b2b/dealer/getSellerWalletInfo`;

  fetchData(url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      callback((status !== 200), data);
    } catch(e) {
      console.error("Error in authenticate", e);
    }
  });
};

export const getDealerDetails = (idx,callback) => {
  let url = `${sellerHostname}/b2b/dealer/getB2bAllDeviceStatus?idx=${idx}`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getAllMakes = (callback) => {
  const url = `${sellerHostname}/b2b/dealer/getAllMakes`;

  fetchData(url, ({ status, response }) => {
    if(status===200){
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
}

export const getShipmentDetails = (idx, dealerId, recent, callback) => {
  let url = `${sellerHostname}/b2b/order/fetchShipments?`;
  if (idx) url += `orderId=${idx}&`;
  if (dealerId) url += `dlrId=${dealerId}`;
  if (recent) url += `recent=${true}`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const getOemAndDealershipDevices = (callback) => {
  const url = `${sellerHostname}/b2b/dealer/getOemDevicesCount`;

  fetchData(url, ({ status, response }) => {
    if(status === 200){
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const saveShipmentRequest = (data, callback) => {
  const url = `${sellerHostname}/b2b/order/requestShipment`;

  postData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
}

export const markInstallationComplete = (data, callback) => {
  const url = `${sellerHostname}/b2b/device/saveDeviceTestResponse`;
  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

export const saveRelayTestStatus = (data, callback) => {
  const url = `${sellerHostname}/b2b/device/saveDeviceTestResponse`;
  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

// <--- User APIs Start ---> //
export const userLogin = (data, callback) => {
  const url = `${crmHostname}/crm/users/login`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

export const sendOTPForUserLogin = (data, callback) =>{
  var url = crmHostname + "/crm/users/users/sendotpwithoutlogin?cmob=" + encodeURIComponent("+91" + data.mob);
  console.log(url);
  fetchData(url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
}

export const userLogout = (callback) => {
  const url = `${crmHostname}/crm/users/logout`;

  postData({}, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);

      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(response);
    }
  });
};

export const authenticateUser = (callback) => {
  const url = `${crmHostname}/crm/users/isloggedin`;

  fetchData(url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      callback((status !== 200), data);
    } catch(e) {
      console.error("Error in authenticate", e);
    }
  });
};

export const getAlerts = (type, callback) => {
  const url = `${glHostname}/gl/users/triggers/getTriggerData`;

  postData({ typ: type }, url, ({ status, response }) => {
    if(status === 200){
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
}

export const saveAlert = (geofence, callback) => {
  const url = `${glHostname}/gl/users/triggers/insertTrigger`;

  if (url) {
    postData(geofence, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const updateAlert = (alert, callback) => {
  const url = `${glHostname}/gl/users/triggers/updatetrigger`;

  if (url) {
    postData(alert, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const removeAlert = (data, callback) => {
  const url = `${glHostname}/gl/users/triggers/deletetrigger`;

  if (url) {
    postData(data, url, ({ status, response }) => {
      try {
        const { data } = JSON.parse(response);
        if (status === 200) callback(null, data);
        else callback(data);
      } catch(e) {
        callback(e);
      }
    });
  }
};

export const getAllRideStats = (data, callback) => {
  const url = `${glHostname}/gl/users/timeline/getstatsbytime`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(e);
    }
  });
}

export const getRoutes = (callback) => {
  const url = `${glHostname}/gl/users/triggers/getVehiclesRoute`;

  fetchData(url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      callback((status !== 200), data);
    } catch(e) {
      console.error("Error in authenticate", e);
    }
  });
}

export const saveRoute = (data, callback) => {
  const url = `${glHostname}/gl/users/triggers/insertVehiclesRoute`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(e);
    }
  });
}

export const getVehiclesWithFilter = (data, callback) => {
  let url = `${sellerHostname}/ev/stats/getFilteredVehicles?fromTs=${data.fromTs}&toTs=${data.toTs}&cmpTyp=${data.cmpTyp}&cmpVal=${data.cmpVal}`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

// <--- User APIs End ---> //

// Sub User APIs

export const createSubUser = (data, callback) => {
  const url = `${glHostname}/gl/users/subUsers/createSubUser`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(e);
    }
  });
}

export const getUserAndVehicleDetails = (data, callback) => {
  let url = `${glHostname}/gl/users/subUsers/getUserAndVehicleDetails?`;
  if (data.idx) url += `idx=${data.idx}&`;

  fetchData(url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const updateSubUser = (data, callback) => {
  const url = `${glHostname}/gl/users/subUsers/updateSubUser`;

  patchData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const manageVehicles = (data, callback) => {
  const url = `${glHostname}/gl/users/subUsers/manageVehicles`;

  postData(data, url, ({ status, response }) => {
    try {
      const { data } = JSON.parse(response);
      if (status === 200) callback(null, data);
      else callback(data);
    } catch(e) {
      callback(e);
    }
  });
}

export const updateSubUserFeaturePermission = (data, callback) => {
  const url = `${crmHostname}/crm/users/users/saveSubUserAccessCodes`;

  patchData(data, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      callback(null, data);
    } else {
      callback(response);
    }
  });
};

export const deleteSubUser = (idx, cb) => {
  const url = `${glHostname}/gl/users/subUsers/deleteSubUser`;

  deleteData({ idx }, url, ({ status, response }) => {
    if (status === 200) {
      const { data } = JSON.parse(response);
      cb(null, data);
    } else {
      cb(response || "failed");
    }
  });
}